const flame = {
  blue: "Azul",
  yellow: "Amarillo",
  orange: "Naranja",
  red: "Rojo",
  focused: "Focalizada",
  semiFocused: "Semi Focalizada",
  highDispersion: "Alta Dispersión"
};

export default flame;
